import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { WagmiConfig } from 'wagmi';
import config from './config/wagmi';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

// 等待 DOM 和安全策略加载完成
const initializeApp = () => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <WagmiConfig config={config}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </WagmiConfig>
    </React.StrictMode>
  );

  reportWebVitals();
};

// 检查文档是否已经加载完成
if (document.readyState === 'loading') {
  // 如果文档仍在加载，等待 DOMContentLoaded 事件
  document.addEventListener('DOMContentLoaded', () => {
    // 给安全策略一些时间初始化
    setTimeout(initializeApp, 1000);
  });
} else {
  // 如果文档已经加载完成，给安全策略一些时间初始化
  setTimeout(initializeApp, 1000);
} 